import { apiClientWithRefreshToken } from "@/api/apiClient";
import { User } from "@/v2/types";

export default async function FindOneUser(id: string): Promise<User> {
    const res = await apiClientWithRefreshToken({
        url: `/users/${id}`,
        method: "GET",
    });
    return res.data;
}
